import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  BBBonusContributorActivationDate,
  BBBonusContributorCurrentDate,
  BBBonusContributors,
  hasBBBContributorsById,
} from '/redux/selector/coach.selector';

import {BusinessBuilderBonusProfileCard} from './BusinessBuilderBonusProfileCard';

export default connect(
  createStructuredSelector({
    BBBonusContributorCurrentDate: BBBonusContributorCurrentDate,
    BBBonusContributorActivationDate: BBBonusContributorActivationDate,

    BBBonusContributors: BBBonusContributors,
    hasBusinessBuilderBonusContributors: hasBBBContributorsById,
  }),
)(BusinessBuilderBonusProfileCard);
